// rm-how-to.js — static How-To page.
//
// Mirrors `Assets/_App/UI/Screens/HowToScreen.cs`. Loads an HTML asset and
// embeds it in the Shadow DOM. Stub for now — the real content lives in the
// Unity port's StreamingAssets/Content/Media/<id>.html files.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class RMHowTo extends RMComponent {
  static styles = `
    :host { display: block; padding: 1.5rem; max-width: 48rem; margin: 0 auto; line-height: 1.5; }
    h2 { margin: 0 0 1rem; }
  `;

  render() {
    return html`
      <h2>How to use Rhythmic Mandarin</h2>
      <p>Pick a list, then a track. Listen all the way through several times — the rhythm of the language is the lesson.</p>
    `;
  }
}
